<template>

    <div class="card border-0 h-800">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body">
            <form ref="form" class="mb-0" :class="{ 'loading-opacity': preloader }">
                <ShortName v-model="inputs.Second_Title" />
                <SupplierDescription v-model="inputs.description" />
                <BillAddress v-model="inputs.BillAddress" />
                <SupplierCountry v-model="inputs.country" />    
                <SupplierState v-model="inputs.state" :country_id="inputs.country.id" />
                <SupplierCity v-model="inputs.city" :state_id="inputs.state.id" />
                <PostalCode v-model="inputs.PostalZipCode" />
                <SupplierPhone v-model="inputs.phone" />
                <SupplierFax v-model="inputs.fax" />
                <SupplierEmail v-model="inputs.Email" />
                <SupplierFda v-model="inputs.fda" />
                <SupplierStatus v-model="inputs.status" :list="stateList" />
                <div class="mt-5 action-buttons">
                    <button type="button" class="btn btn-primary mr-2" @click="continueBy">{{
                        $t('continue') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import {validateInputs } from "../../../../../utils";
import ShortName from '../components/ShortName.vue';
import SupplierDescription from '../components/SupplierDescription.vue';
import BillAddress from '../components/BillAddress.vue';
import SupplierCountry from '../components/SupplierCountry.vue';
import SupplierState from '../components/SupplierState.vue';
import SupplierCity from '../components/SupplierCity.vue';
import PostalCode from '../components/PostalCode.vue';
import SupplierPhone from '../components/SupplierPhone.vue';
import SupplierFax from '../components/SupplierFax.vue';
import SupplierEmail from '../components/SupplierEmail.vue';
import SupplierFda from '../components/SupplierFda.vue';
import SupplierStatus from '../components/SupplierStatus.vue';

export default {
    name: "add_supplier_form",
    mixins: [FormMixin, ModalMixin],
    components :{
        ShortName, SupplierDescription, BillAddress, SupplierCountry, SupplierState, SupplierCity, PostalCode, SupplierPhone, SupplierFax, SupplierEmail, SupplierFda, SupplierStatus
    },
    data() {
        return {
            preloader: false,
            inputs: {
                Second_Title: '',
                description: '',
                BillAddress: '',
                fax: '',
                country: { id: null, name: null },
                state: { id: null, name: null },
                city: { id: null, name: null },
                PostalZipCode: '',
                phone: '',
                Email: '',
                BillAddress: '',
                status: 'active',
                company_type_id: 2
            },
            stateList: [
                { id: 'active', value: "Active" },
                { id: 'inactive', value: "Inactive" }
            ],
        };
    },

    methods: {
        continueBy() {
            const validations = {
                Second_Title: { required: true,  message: 'long name must be between 3 and 100 characters' },
                BillAddress: { required: true, message: 'the BillAddress is required' },
                'country.id': { required: true, message: 'the country is required' },
                'state.id': { required: true, message: 'the state is required' },
                'city.id': { required: true, message: 'the city is required' },
                PostalZipCode : { required: true, message: 'the postal Zip Code is required' },
            };

            if (!validateInputs(this, this.inputs, validations)) {
                return;
            }

            window.location.href = this.$router.resolve({
                name: 'Contacts-suppliers',
                query: { 'tab': 'Contacts' }
            }).href;
        },
    },

    watch: {
        inputs: {
            deep: true, // Para detectar cambios profundos en el objeto
            handler(newVal) { // Guardamos los inputs en localStorage
                localStorage.setItem('DataSupplier', JSON.stringify(newVal));
            }
        }
    },

    created() {
        const savedInputs = localStorage.getItem('DataSupplier');
        if (savedInputs) {
            this.inputs = JSON.parse(savedInputs);
        }
    }
}
</script>
